export default __webpack_public_path__ + "static/media/ic_ireland.c672dd7d.svg";